export default {
    getTypeList: '/auth/dept/list', //获取部门类型
    getDepartmentList:'/auth/token/condition/department', //获取部门机构列表
    addDepart: '/auth/dept/addDept', //新增部门、部门类型
    updateDepart: '/auth/dept/updateDept', //编辑部门、部门类型
    delDepart:'/auth/dept/deleteDept', //删除部门、部门类型
    getPosIdentList:'/auth/rankMark/pageMark', //获取职级、标识列表
    getNewPosIdentItem: '/auth/rankMark/addRankMark', //新增时获取一项新的职级、标识
    addPosition: '/auth/rankMark/updateRank', //新增职级-保存
    addIdentifiy: '/auth/rankMark/bindingMark', //新增标识-保存
    unbindIdentify: '/auth/rankMark/deleteMarkPosition', //标识-解绑
    getPosDeptSearchResult: '/auth/token/condition/deptOrPosition', //职位或部门查询
}


// WEBPACK FOOTER //
// ./src/api/architectureManagement.js